import Step from '@/lib/Step';
import {Question} from '@/lib/Question';
import store from "@/store";
import {ArraySection} from "@/lib/ArraySection";
import Condition from "@/lib/Condition";
import {ArraySectionItem} from "./ArraySectionItem";

export default class Section {
    public ranking: number = 0;
    public additionalIndex = 0;
    public labelIndex = 0;
    public questions: Question[] = [];
    public isAdditional = false;
    public parentSection: Section | null = null;
    public children: Section[] = [];
    public arraySection: ArraySection | null = null;
    public arraySectionItems: ArraySectionItem[] = [];
    public conditions: Condition[] = [];
    public labelQuestions: Question[] = [];
    public labelQuestionIds: number[] = [];
    private _label: string = '';
    private labelInitialized = false;

    constructor(public id: number, public title: string, public description: string = '', public step: Step, public additionalLabel: string = '', public multiple: boolean = false, public incrementAdditional: boolean = true, public arraySectionIds: number[] = []) {
        this.initLabel();
    }

    public get label(): string {

        if (!this.labelInitialized) {
            this.initLabel();
        }
        return this._label.trim();
    }

    public set label(label: string) {
        this._label = label;
    }

    public updateLabel() {
        let label = '';
        this.labelQuestions.map((question: Question) => {
            if (question.currentResponse) {
                const answerArray = question.currentResponse!.value.split(' ');
                label += ' ' + answerArray.slice(-2).join(' ');
            }
        });
        this.label = (this.additionalLabel || this.title);
        if (label.trim().length) {
            this.label = this.label + ' :' + label;
        }
    }

    private initLabel() {
        if (this.labelQuestionIds.length) {
            this.labelQuestionIds.forEach((questionId: number) => {
                const question = store.getters.getQuestion(questionId) as Question;
                console.log(question);
                question.changedEvent.on(() => {
                    this.updateLabel();
                    console.log('changed');
                });
                this.labelQuestions.push(question);
            });
        } else {
            this._label = this.additionalLabel || this.title;
            if (this.labelIndex) {
                this._label = this._label + ' ' + this.labelIndex;
            }
        }

        this.labelInitialized = true;
    }


    public canDisplay() {
        return this.allConditionsFulfilled() && this.questions.some((question: Question) => question.canDisplay());
    }

    public allConditionsFulfilled() {
        if (0 === this.conditions.length) {
            return true;
        }
        return this.conditions.every((condition: Condition) => condition.isFulfilled);
    }

    public getChildCount() {
        return this.children.length + 1;
    }

    public getAdditional(index: number): Section | undefined {
        if (index == this.additionalIndex) {
            return this;
        }
        return this.children.find((section: Section) => section.additionalIndex === index);
    }

    public getAdditionalOrCreateIfNotExist(index: number) {
        let additional = this.getAdditional(index);
        if (typeof additional === typeof undefined) {
            additional = this.createAdditional(index);
        }

        return additional;
    }

    public isLastOfStep(){
        const sections = this.step.sections.filter((section: Section) => section.allConditionsFulfilled());
        if(sections.length === 0){
            return false;
        }
        const last = sections[sections.length - 1];
        return last.id === this.id;
    }

    public isLastChild() {
        if (this.parentSection === null) {
            return this.multiple ? this.children.length === 0 : false;
        }
        return this.parentSection.getLastChildIndex() === this.additionalIndex;
    }

    public getLastChildIndex(): number | null {
        const indexes = this.children.map((section: Section) => section.additionalIndex);
        return indexes.length > 0 ? Math.max(...indexes) : null;
    }

    public getLastChildLabelIndex(): number {
        const indexes = this.children.map((section: Section) => section.labelIndex);

        return indexes.length > 0 ? Math.max(...indexes) : 0;
    }

    public createArraySection() {
        this.arraySection = new ArraySection(this);
    }


    public createAdditional(index: number = 0) {

        //const currentIndex = index === 0 ? (this.getLastChildIndex() || 1) + 1 : index;
        const labelIndex = this.getLastChildLabelIndex() + 1;

        const currentIndex = index === 0 ? this.additionalIndex + this.children.length + 1 : index;
        const additional = this.doCreateAdditional(currentIndex, labelIndex);
        store.commit('addSection', additional);
        this.step.sections.push(additional);
        store.state.currentBranch.dispatchQuestions();
        this.updateLabel();
        additional.initLabel();
        additional.updateLabel();
        console.log(additional);
        return additional;
    }

    public doCreateAdditional(index: number, labelIndex: number) {
        let label = this.additionalLabel && this.additionalLabel.length > 0 ? this.additionalLabel : this.title;
        if (this.incrementAdditional) {
            const label = this.label + ' ' + labelIndex;
        }
        const additional = new Section(0, label, this.description, this.step, '', false, false, []);
        this.children.push(additional);
        additional.parentSection = this;
        additional.labelIndex = labelIndex;
        additional.isAdditional = true;
        additional.additionalIndex = index;
        additional.questions = this.questions.map((question: Question) => {
            return Section.createAdditionalQuestion(question, this.id, index, additional);
        });
        additional.questions.forEach((question: Question) => {
            if (this.labelQuestionIds.includes(question.originalId)) {
                additional.labelQuestionIds.push(question.id);
            }
        });

        return additional;
    }

    public static createAdditionalQuestionFromArraySectionItem(question: Question, arraySectionItem: ArraySectionItem): Question {
        const additionalQuestion = Section.createAdditionalQuestion(question, arraySectionItem.additional.id, arraySectionItem.additionalIndex, arraySectionItem.additional);
        additionalQuestion.arraySectionItem = arraySectionItem;
        return additionalQuestion;
    }

    public static createAdditionalQuestion(question: Question, sectionId: number, index: number, additional: Section) {
        const id = parseInt('' + (sectionId * 100) + question.id + index);
        const additionalQuestion = new Question(
            id,
            question.responseType,
            question.label,
            additional,
            question.required,
            question.multiple,
            question.regexString,
            question.description,
            question.errorMessage,
            question.filteredByQuestionId,
            question.hasComment,
            question.conditionIsOr,
            question.displayWidth,
            question.placeholder,
            question.inline,
            question.unit,
        );
        additionalQuestion.loadFromServer = question.loadFromServer;
        additionalQuestion.options = question.options;
        additionalQuestion.originalId = question.id;
        store.commit('addQuestion', additionalQuestion);
        // additionalQuestion
        return additionalQuestion;

    }
}
